// Add new posts here — content lives in public/blog/posts/{slug}.md

export const posts = [
  {
    slug: 'kitchen-sessions-vol-3',
    title: 'New Release: Kitchen Sessions Vol. 3',
    date: '2026-03-26',
    excerpt: 'The Kitchen Sessions are finally Here',
    image: '/images/blog/kitchen-sessions.svg',
    published: true,
  },
  {
    slug: 'kitchen-sessions-vol-2',
    title: 'New Release: Kitchen Sessions Vol. 2',
    date: '2026-03-26',
    excerpt: 'The Kitchen Sessions are finally Here',
    image: '/images/blog/kitchen-sessions.svg',
    published: true,
  },
  {
    slug: 'kitchen-sessions-are-out',
    title: 'The Kitchen Sessions are Here',
    date: '2026-03-26',
    excerpt: 'The Kitchen Sessions are finally Here',
    image: '/images/blog/kitchen-sessions.svg',
    published: true,
  },
  {
    slug: 'welcome',
    title: 'Welcome to waabm',
    date: '2026-03-26',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut pretium tempus elit ac faucibus. Mauris venenatis augue quis nibh mattis volutpat. Donec rhoncus leo laoreet dui blandit dictum.',
    image: '/images/blog/welcome.svg',
    published: true,
  },
  {
    slug: 'hello-world',
    title: 'Hello World',
    date: '2026-03-25',
    excerpt: 'Hello world from WAABM.music blog — a space for updates, stories, and creative notes.',
    image: '/images/blog/hello-world.svg',
    published: true,
  },
].sort((a, b) => new Date(b.date) - new Date(a.date));

export function getPost(slug) {
  return posts.find((p) => p.slug === slug && p.published !== false) ?? null;
}
